import React from "react"
import Modal from "../../../../components/Modal"
import MinMaxInput from "../../../User/getAllUsers/components/MinMaxInput"
import TextInput from "../../../User/getAllUsers/components/TextInput"
import RadioInput from "../../../User/getAllUsers/components/RadioInput"
import DateInput from "../../../User/getAllUsers/components/DateInput"

interface FiltersProps {
  isOpen: boolean
  onClose: () => void
  filters: any
  onFilterChange: (key: string, value: string) => void
  handleFetchData: () => void
  handleClear: () => void
}

const Filters: React.FC<FiltersProps> = ({
  isOpen,
  onClose,
  filters,
  onFilterChange,
  handleFetchData,
  handleClear,
}) => {
  return (
    <>
      {isOpen && (
        <div className="flex w-full items-center justify-center">
          <Modal
            classname="fixed inset-0 bg-gray-800 bg-opacity-50 p-3 flex items-center justify-end z-50"
            classname2="relative bg-white rounded-3xl w-full md:w-1/2 h-full"
            onClick={onClose}
          >
            <div className="w-full p-4 h-full overflow-y-auto overscroll-contain">
              <div className="w-full">
                <h2 className="font-semibold text-2xl">Filtrele</h2>
                <div className="border"></div>
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-4">
                <MinMaxInput
                  value={filters.min_age}
                  setValue={(e) => {
                    onFilterChange("min_age", e.target.value)
                  }}
                  placeholder="Min. Yaş"
                />
                <MinMaxInput
                  value={filters.max_age}
                  setValue={(e) => {
                    onFilterChange("max_age", e.target.value)
                  }}
                  placeholder="Max. Yaş"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <MinMaxInput
                  value={filters.min_follower}
                  setValue={(e) => {
                    onFilterChange("min_follower", e.target.value)
                  }}
                  placeholder="Min. Takipçi"
                />
                <MinMaxInput
                  value={filters.max_follower}
                  setValue={(e) => {
                    onFilterChange("max_follower", e.target.value)
                  }}
                  placeholder="Max. Takipçi"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-3">
                <TextInput
                  value={filters.country}
                  setValue={(e) => {
                    onFilterChange("country", e.trim())
                  }}
                  placeholder="Ülke"
                />
                <MinMaxInput
                  value={filters.max_cost}
                  setValue={(e) => {
                    onFilterChange("max_cost", e.target.value)
                  }}
                  placeholder="Max. Tutar"
                />
              </div>
              <div className="flex w-full justify-between items-center gap-4 mt-4">
                <DateInput
                  value={filters.created_at_start || ""}
                  setValue={(value) => onFilterChange("created_at_start", value)}
                  placeholder="Oluşturulma Başlangıç Tarihi"
                />
                <DateInput
                  value={filters.created_at_end || ""}
                  setValue={(value) => onFilterChange("created_at_end", value)}
                  placeholder="Oluşturulma Bitiş Tarihi"
                />
              </div>
              <div className="flex-col w-full justify-center items-center gap-4 mt-3">
                <div className="flex justify-between items-start">
                  <RadioInput
                    placeholder="Platform"
                    value={filters.platform}
                    onChange={(e) => onFilterChange("platform", e.trim())}
                    option1="insta-post"
                    option2="insta-reels"
                    option3="insta-story"
                    option4="tiktok"
                    option5="ugc"
                    label1="Instagram Post"
                    label2="Instagram Reels"
                    label3="Instagram Story"
                    label4="TikTok"
                    label5="UGC"
                  />
                  <RadioInput
                    placeholder="Kampanya Aşaması"
                    value={filters.step}
                    onChange={(e) => onFilterChange("step", e.trim())}
                    option1="1"
                    option2="2"
                    option3="3"
                    option4="4"
                    option5="5"
                    label1="1"
                    label2="2"
                    label3="3"
                    label4="4"
                    label5="5"
                  />
                  <RadioInput
                    placeholder="Oluşturulma Tarihi"
                    value={filters.created_at_start}
                    onChange={(e) => {
                      onFilterChange("created_at_start", e.trim())
                      onFilterChange("created_at_end", new Date().toISOString().split("T")[0])
                    }}
                    option1="last_3_months"
                    option2="last_month"
                    option3="last_week"
                    label1="Son 3 Ay"
                    label2="Son 1 Ay"
                    label3="Son 1 Hafta"
                  />
                </div>
                <div className="flex mt-4 justify-between items-start">
                  <RadioInput
                    placeholder="Cinsiyet"
                    value={filters.gender}
                    onChange={(e) => onFilterChange("gender", e.trim())}
                    option1="male"
                    option2="female"
                    label1="Erkek"
                    label2="Kadın"
                  />
                  <RadioInput
                    placeholder="Silinme Durumu"
                    value={filters.deleted}
                    onChange={(e) => onFilterChange("deleted", e.trim())}
                    option1="true"
                    option2="false"
                    label1="Silinmiş"
                    label2="Aktif"
                  />
                  <RadioInput
                    placeholder="Ürün Gönderimi"
                    value={filters.barter}
                    onChange={(e) => onFilterChange("barter", e.trim())}
                    option1="true"
                    option2="false"
                    label1="Var"
                    label2="Yok"
                  />
                  <RadioInput
                    placeholder="Görünürlük"
                    value={filters.visibility}
                    onChange={(e) => onFilterChange("visibility", e.trim())}
                    option1="true"
                    option2="false"
                    label1="Yayında"
                    label2="Yayında Değil"
                  />
                </div>
              </div>

              <div
                className="flex flex-row justify-between w-full mt-24 py-4 space-x-24"
                style={{
                  boxShadow: "0px -12px 20px -10px rgba(0, 0, 128, 0.1)",
                }}
              >
                <button className="text-blue h-12 rounded-full" onClick={handleClear}>
                  Temizle
                </button>
                <button
                  className="text-blue bg-blue-100 h-12 px-4 rounded-full"
                  onClick={() => {
                    handleFetchData()
                    onClose()
                  }}
                >
                  <span>Uygula</span>
                </button>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </>
  )
}

export default Filters
